import React, { PropsWithChildren, useCallback, useEffect, useReducer, useRef } from 'react';

import UserContext, { initialState } from './user.context';
import { ActionPayload, ActionType, State } from './type';

interface Props {}

export const UserContextProvider: React.FC<PropsWithChildren<Props>> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const stateRef = useRef(state);
  useEffect(() => {
    stateRef.current = state;
  }, [state]);

  const handleDispatch = useCallback(
    (callback: (state: State, dispatch: React.Dispatch<ActionPayload>) => void) => {
      callback?.(stateRef.current, dispatch);
    },
    [dispatch]
  );

  return <UserContext.Provider value={{ state, dispatch: handleDispatch }}>{children}</UserContext.Provider>;
};

function reducer(state: State, action: ActionPayload): State {
  switch (action.type) {
    case ActionType.SET_USER:
      return {
        ...state,
        user: action.payload.user,
      };
    default:
      return state;
  }
}


